"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EATRoadwayType = exports.EATPlaceType = exports.EATLaneType = exports.EATLaneState = exports.EATDirection = void 0;
var EATPlaceType;
exports.EATPlaceType = EATPlaceType;
(function (EATPlaceType) {
  EATPlaceType["Interstate"] = "Interstate";
  EATPlaceType["USHighway"] = "USHighway";
  EATPlaceType["StateHighway"] = "StateHighway";
  EATPlaceType["Arterial"] = "Arterial";
  EATPlaceType["MilePost"] = "MilePost";
  EATPlaceType["ExitRamp"] = "ExitRamp";
  EATPlaceType["CountyRoad"] = "CountyRoad";
  EATPlaceType["Unknown"] = "Unknown";
})(EATPlaceType || (exports.EATPlaceType = EATPlaceType = {}));
;
var EATRoadwayType;
exports.EATRoadwayType = EATRoadwayType;
(function (EATRoadwayType) {
  EATRoadwayType["Interstate"] = "Interstate";
  EATRoadwayType["USRoute"] = "USRoute";
  EATRoadwayType["StateRoute"] = "StateRoute";
  EATRoadwayType["Unknown"] = "Unknown";
})(EATRoadwayType || (exports.EATRoadwayType = EATRoadwayType = {}));
var EATLaneState;
exports.EATLaneState = EATLaneState;
(function (EATLaneState) {
  EATLaneState["Open"] = "Open";
  EATLaneState["Affected"] = "Affected";
  EATLaneState["Closed"] = "Closed";
  EATLaneState["Unknown"] = "Unknown";
})(EATLaneState || (exports.EATLaneState = EATLaneState = {}));
;
var EATLaneType;
exports.EATLaneType = EATLaneType;
(function (EATLaneType) {
  EATLaneType["RightExitRamp"] = "RightExitRamp";
  EATLaneType["LeftTurningLane"] = "LeftTurningLane";
  EATLaneType["RightTurningLane"] = "RightTurningLane";
  EATLaneType["ThroughLane"] = "ThroughLane";
  EATLaneType["SoftShoulder"] = "SoftShoulder";
  EATLaneType["LeftShoulder"] = "LeftShoulder";
  EATLaneType["LeftEntranceRamp"] = "LeftEntranceRamp";
  EATLaneType["LocalLanes"] = "LocalLanes";
  EATLaneType["RightShoulder"] = "RightShoulder";
  EATLaneType["LeftMergingLane"] = "LeftMergingLane";
  EATLaneType["LeftExitRamp"] = "LeftExitRamp";
  EATLaneType["Gore"] = "Gore";
  EATLaneType["RightEntranceRamp"] = "RightEntranceRamp";
  EATLaneType["RightMergingLane"] = "RightMergingLane";
  EATLaneType["Unknown"] = "Unknown";
})(EATLaneType || (exports.EATLaneType = EATLaneType = {}));
;
var EATDirection;
exports.EATDirection = EATDirection;
(function (EATDirection) {
  EATDirection["North"] = "North";
  EATDirection["South"] = "South";
  EATDirection["East"] = "East";
  EATDirection["West"] = "West";
  EATDirection["NorthSouth"] = "NorthSouth";
  EATDirection["EastWest"] = "EastWest";
  EATDirection["Any"] = "Any";
  EATDirection["AllDirections"] = "AllDirections";
  EATDirection["Unknown"] = "Unknown";
})(EATDirection || (exports.EATDirection = EATDirection = {}));
;